import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
@Component({
    selector: 'se-stepper-side-nav-exams',
    templateUrl: './se-stepper-side-nav-exams.component.html',
    styleUrls: ['./se-stepper-side-nav-exams.component.scss'],
    standalone: false
})
export class SeStepperSideNavExamsComponent implements OnChanges {

    @Input() formData : any;
    @Input() currentStepValid : boolean = false;
    @Input() disableButton : boolean = false;

    @Output() deleteExam : EventEmitter<any> = new EventEmitter<any>();
    newFormData : any[];
    constructor (private cdr : ChangeDetectorRef) {}

    ngOnChanges (changes : SimpleChanges) : void {
        this.cdr.detectChanges();

        if (changes.formData || this.formData.length === 0) {
            this.newFormData = this.normalizedFormData();
        }
    }

    private normalizedFormData () : any[] {
        if (Array.isArray(this.formData)) {
            return this.formData;
        } else if (typeof this.formData === 'object' && this.formData !== null) {
            return [this.formData];
        } else {
            return [];
        }
    }

    objectKeys (obj : any) : string[] {
        return Object.keys(obj);
    }

    _deleteExam (event : MouseEvent, data : Object, index: number) {
        event.stopPropagation();
        event.preventDefault();
        this.deleteExam.emit({ data: data, index: index });
    }

    _isTooltipDisabled(element) {
        return element.offsetWidth >= element.scrollWidth;
    }
}
